angular.module('samcart.factories').factory('Exception', ['Checkout', function(Checkout) {
    var Exception = {

        

    };

    return Exception;
}]);